"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = void 0;
const index_1 = require("../index");
const icons_1 = require("../../icons");
const react_1 = __importDefault(require("react"));
const Banner = ({ color, children, action, position = 'bottom', closeButton, ...rest }) => {
    const isTopBanner = position === 'top';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(index_1.Box, { position: "fixed", bottom: isTopBanner ? 'auto' : 0, top: isTopBanner ? 0 : 'auto', left: 0, right: 0, bgcolor: `${color}.main`, px: 3, py: 2, zIndex: 1, ...rest },
            closeButton && (react_1.default.createElement(index_1.Box, { position: "absolute", top: 2, left: 2 },
                react_1.default.createElement(index_1.IconButton, { ...closeButton },
                    react_1.default.createElement(icons_1.Close, null)))),
            react_1.default.createElement(index_1.Grid, { spacing: 1, container: true, alignItems: "center", justifyContent: "center" },
                react_1.default.createElement(index_1.Grid, { item: true },
                    react_1.default.createElement(index_1.Typography, { weight: "regular", variant: "body2", color: "error.contrastText" }, children)),
                react_1.default.createElement(index_1.Grid, { item: true }, action)))));
};
exports.Banner = Banner;
exports.default = exports.Banner;
